var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_2809",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_27_2809)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_2809)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_27_2809",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27_2809",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_27_2809",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAgKADAAQAAAABAAAAgAAAAABIjgR3AAAGxElEQVR4Ae1bXagVVRi95k36M0rKkqR/rSSyegos0ggfIgqKiIqEXnrKeojQB8Fb0HtGEET1EEUU9dBDtx/LlyK9lPQvphYUJEoW3DALTW195OBx7jmzZ8/Za858M2vD4pyZ/c0336y1Zu+z55wzNqYmBsSAGBADYkAMiAExIAbEQLcYmFXD5c7HORYB5wIn13C+NpziIC5iD7AdmPZ4QbNR9CpgCjgMHBUqcWBG2AjcBrhpl6LSLwGJnpaDSXA6r+kuWIoC90l8mvl3gNsFTTWBzfU/S3ya+NmIuhkcz0llApurU7VnkGhFqmTKM5CBhej5A9gyMCKiI9Uq4EKc80dgPOLcCq3OwG849ALgUPUU/x950rAJjh1/F14lfiIyS6SxJfXNJeKCIalEWxY4ky0FPwT2B+LUfZwBm07POb45491N2PPRjL0j2vEZzpt9SOn3um5EdXk+7Q0BTl9KcXGppoC5gWJ+CPSreyYDIc5CnM/M2GdPKgP0Sa1dHhiQATyoRKxRBiCS6yG1DOBBJWKNMgCRXA+pZQAPKhFrlAGI5HpILQN4UIlYowxAJNdDahnAg0rEGmUAIrkeUssAHlQi1igDEMn1kFoG8KASsUYZgEiuh9QygAeViDXKAERyPaSWATyoRKxRBiCS6yG1DOBBJWKNMgCRXA+pZQAPKhFrlAGI5HpILQN4UIlYowxAJNdDahnAg0rEGmUAIrkeUssAHlQi1igDEMn1kFoG8KASsUYZgEiuh9QygAeViDXKAERyPaSWATyoRKxRBiCS6yG1DOBBJWKNMgCRXA+pZQAPKhFrlAGI5HpILQN4UIlYowxAJNdDahnAg0rEGmUAIrkeUssAHlQi1igDEMn1kFoG8KASsUYZgEiuh9QygAeViDXKAERyPaSWATyoRKxRBiCS6yG1DOBBJWKNMgCRXA+pZQAPKhFrlAGI5HpILQN4UIlYowxAJNdDahnAg0rEGmUAIrkeUssAHlQi1igDEMn1kFoG8KASsUYZgEiuh9QygAeViDXKAERyPaQe91AkqcaLkddwCvA78D1wAOhU65oB5kHd1cBDwEU5pQ9i+2PgWeD9XJ82Awx8i/6jBbgncHwd3VbD3oIae+t/B3Hn1VFUwTnODtT6ZsGxpbu68BnAhvgNgBE2vyQzdyDuG2BlyXi3YW03wGIosxl4tIJCZpZJYAKYDbSytdkAd0OxKeDaIZQz4dcDG4EFQ+Rp7KFtNEA25L8F1s9KxPwK5PkKaN2U0DYDXAGRtgBVhnwcVthaOSW0yQAPQr4vgKWFMp7YaauCT4AjJ+4euJVNCbZMHPUqYWCRo+gY5TIwG/J7l3Fl3vdOETbE7wbKHJfFmHmYU0Ity8BUZhmVAa7EBXwdKdzfiH+sz4XbEP9BZK5/ET8BMFYJMgCILWqr0LkfyO7IMq/bEX9NQVITcgIwYcvky2I2IT71KkEGAKn92qnY+QKQkV/29RUcc0a/hH32NWFKkAH6CHMV9tkTurKiW9wB4GEgto16SpABcopVGfK3IcfVuTwxm6OcEmSAY0rZsP0qEHPXW6wN+acBKdoopgQZAMotAb4DYsT/E/H3A6lb3VNC5w1gQ/5fQIz4WxF/eWrle/LVOSV01gBzQfhrQIzw2ZBvK4Q6Wh1TQicNcB3U2wHEiD+N+HvrUD13DvaU0DkDVBnyP4col+WEqXPTvktZAzAeHHXGADbkvw7E3PVHEL8BmAM0oTGmhE4Y4HqotxOIEX8f4m9vguq5GlJPCa03gD2d+weIEX8K8ZfkiG/SZsopwZUBQo9n7+tRyX6l8zYQI/xhxD8NjAMe2q0ocg8Qc427Eb8cyNr5eFN0/BtZYBNePw0UO4n+M4EbgZ8CsfmL3ov4lYC3Zt8ObgLy11O0nX29bKPcc4Fjn0d/Y9rLqKTowqzP7uJQTL7f/qiR+mtWpKyt2YOjp4Aq157nIr/9SG1XUeJEDyAmX+Aw23YnrAeMwDa0KlNCEX+2ClrUJGJORzH26byo6LJ9vyLPcqBtrcqUMIgz+5l645r9EndQwWX3248tbTnV1mYj2pPAMFOC/YfRls+Na7YEehcoK3Zv3CEctxawHF1ow0wJq5tMkH3//h7QK27o/S+IX9bkiyLVFjsl2Oeix0m1JE1rd/ETwDRQJL4Ngy8C9sCjq82mBPuFcujz01bEUG6SWUTm7YGP/T/PsBhYCNiveHcBtj62paO9Vxsbs6+x7wRuAezfTfah2p5/2AM2m1btOYuaGBADYkAMiAExIAbEgBgQA2JADIgBMSAGxIAYEANiQAyIATEgBqIZ+A99oG9BViXI4QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstSave);
export default __webpack_public_path__ + "static/media/instSave.82f36e15945da2b5170be732606fad85.svg";
export { ForwardRef as ReactComponent };